import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage,
    type = 'website',
    noindex = false
}): ReactNode => {
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const isDefaultImage = ogImage === siteConfig.ogImage

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content={type} />
            <meta property='og:url' content={siteConfig.url} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content='nb_NO' />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && isDefaultImage && <meta property='og:image:width' content='1200' />}
            {ogImage && isDefaultImage && <meta property='og:image:height' content='630' />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
            {noindex && <meta name='robots' content='noindex' />}
        </Head>
    )
}
